var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leaveProcess" },
    _vm._l(_vm.processList, function (item, index) {
      return _c(
        "div",
        { key: index + "DsfTeasLeaveProcess", staticClass: "processOuterItem" },
        [
          _c("div", { staticClass: "title" }, [
            _c("div", { staticClass: "line" }),
            _c("div", [_vm._v(_vm._s(item.month))]),
          ]),
          _c(
            "div",
            {
              staticClass: "typeListContent",
              class: index == _vm.processList.length - 1 ? "typenopadding" : "",
            },
            _vm._l(item.list, function (innerItem, innerIndex) {
              return _c(
                "div",
                {
                  key: innerIndex + "type",
                  staticClass: "innerItem",
                  class: innerIndex == item.list.length - 1 ? "nopadding" : "",
                },
                [
                  _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "time" }, [
                      _vm._v(_vm._s(innerItem.leaveDays)),
                    ]),
                    _c("div", { staticClass: "type" }, [
                      _vm._v(_vm._s(innerItem.leaveType)),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }